import React from 'react';
import './Title.less';

export type Title = {
  level?: 1 | 2 | 3 | 4;
  bold?: boolean;
  paddingBottom?: 1 | 2 | 3 | 4;
  rows?: 1 | 2 | 3 | null;
  alt?: string;
  textColor?:
    | 'dark-100'
    | 'dark-50'
    | 'dark-30'
    | 'dark-20'
    | 'dark-10'
    | 'indicator-good'
    | 'indicator-caution'
    | 'indicator-bad'
    | 'indicator-neutral'
    | 'light'
    | 'white'
    | 'black'
    | 'primary';
} & Omit<
  React.HTMLAttributes<HTMLHeadingElement>,
  'style' | 'className' | 'title'
>;

const TTitle: React.FC<Title> = ({
  children,
  level = 1,
  bold = false,
  paddingBottom,
  rows,
  textColor = 'dark-100',
  alt,
  ...props
}) => {
  const classNames = [
    `t-title t-${level} ${
      bold && 't-bold'
    } t-title-paddingBottom-${paddingBottom} t-text-color-${textColor}
    t-title-row-${rows}
    `,
  ];

  const Tag: any = `h${level}`;

  return (
    <Tag className={classNames.join(' ')} title={alt} {...props}>
      {children}
    </Tag>
  );
};

export default TTitle;
